// TODO: Load the JSON file when Node.js supports that.

const markdownExtension = [
	'md',
	'markdown',
	'mdown',
	'mkdn',
	'mkd',
	'mdwn',
	'mkdown',
	'ron',
];

export default markdownExtension;
